import Box from '@mui/material/Box';
import CircularProgress, {
    CircularProgressProps,
} from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { Property } from "csstype";

export function CircularProgressWithLabel(
    props: CircularProgressProps & { value: number } & { height?: Property.Height<string | number> | undefined } & { width?: Property.Width<string | number> | undefined },
) {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex', width: props.width ?? 45, height: props.height ?? 45 }}>
            <CircularProgress variant="determinate" {...props} color="secondary" style={{ height: '100%', width: '100%', padding: '3px' }} />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography
                    variant="caption"
                    component="div"
                    color="text.secondary"
                    textAlign="center"
                >{`${Math.round(props.value)}%`}</Typography>
            </Box>
        </Box>
    );
}